













import { defineComponent } from "@vue/composition-api";
import BasePage from "@/components/BasePage";
import FooterPolicy from "@/components/FooterPolicy";

export default defineComponent({
  name: "PageLanding",
  components: { FooterPolicy, BasePage },
  created() {
    this.$router.replace({ name: "home" });
  },
});
